var render = function render(){var _vm=this,_c=_vm._self._c;return _c('requisicoes',{attrs:{"dataServicos":_vm.obterDataServicos(),"rotaDetalhar":"Gescon_Apoios_Requisicoes_Detalhar","rotaListagem":"Gescon_Apoios_Requisicoes"}})
}
var staticRenderFns = []

export { render, staticRenderFns }